import axios from 'axios';
import { req } from './axiosFun';

/**
 * 公共
 **/
// 系统字典
export const param = (category) => {
  return req("get", "/api/auth/dict/param?category="+category)
};
// 文件上传
export const upload = (params) => { return axios.post("/api/common/file/image/upload",params).then(res => res.data) };
// 视频文件上传
export const uploadVideo = (params) => {
  return req("post", "/api/auth/upload/video",params)
};
// 上传临时图片
export const uploadImgTmp = (params) => {
  return req("post", "/api/auth/upload/tmp/image",params)
};
// 上传pdf文件
export const uploadPdf = (params) => {
  return req("post", "/api/auth/upload/pdf",params)
};
// 省市区下拉列表
export const locationArea = (pid) => {
  return req("get", "/api/auth/location/area?pid=" + pid)
};
// 文件上传获取token
export const getToken = () => {
  return req("POST", "/api/auth/file/gen/token")
};
// 图片转换
export const thumbListPic = (url) => {
  return req("get", "/api/auth/product/gen/thumb/list/pic?url=" + url)
};



// WEBPACK FOOTER //
// ./src/api/commonMG.js